import { render, staticRenderFns } from "./VgViewField.vue?vue&type=template&id=f7899428&scoped=true&"
import script from "./VgViewField.vue?vue&type=script&lang=js&"
export * from "./VgViewField.vue?vue&type=script&lang=js&"
import style0 from "./VgViewField.vue?vue&type=style&index=0&id=f7899428&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7899428",
  null
  
)

export default component.exports